/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css, cx } from "@panda/css";
import { ResponsiveContainer } from "./ResponsiveContainer.atom";
import { SectionContainer } from "./SectionContainer.atom";
import { ArticleChildrenWrapProps, ArticleChildrenWrap } from "./ArticleChildrenWrap.atom";

export const articleSectionContainerStyles = css({
	paddingBlock: "eds.dimension.24",
});

export const ArticleContainer = ({
	disable,
	className = "",
	children,
	...rest
}: ArticleChildrenWrapProps): React.ReactNode => {
	if (disable) {
		return children;
	}

	return (
		<ResponsiveContainer className={cx("article-container", className)}>
			<SectionContainer disablePaddingBlock className={articleSectionContainerStyles}>
				<ArticleChildrenWrap {...rest}>{children}</ArticleChildrenWrap>
			</SectionContainer>
		</ResponsiveContainer>
	);
};
